export default __webpack_public_path__ + "static/media/TRAPAC.b534b8f9.svg";